/**
* Created by vouill on 2019-02-05.
*/

<template>
  <div class="content">
    <h2> <img
      v-if="authorPicture"
      :src="authorPicture.file.url" >{{ author.fields.lastname }} {{ author.fields.firstname }}</h2>
    <VShowdown :source="author.fields.description"/>
  </div>
</template>

<style scoped lang="scss">
.content {
  padding: 1em;
}

img {
  height: 100px;
  width: 100px;
  object-fit: cover;
  border-radius: 50%;
  object-position: 50% 50%;
  margin-right: 1em;
}
h2 {
  display: flex;
  align-items: center;
}
</style>
<script>
import { getAsset } from "../../utils/contentful";

export default {
  name: "AuthorContent",
  props: { author: Object, includes: Object },
  components: {},
  computed: {
    authorPicture() {
      return getAsset(this.includes, this.author.fields.authorPicture?.sys.id)
        ?.fields;
    }
  }
};
</script>
